<template>
  <div>
    <!-- <el-select v-model="activeStore" placeholder="请选择">
      <el-option
        v-for="item in storeList"
        :key="item.priority"
        :label="item.location"
        :value="item.priority">
      </el-option>
    </el-select> -->
  </div>
</template>

<script>
export default {
  model: {
    prop: 'storeItem',
    event: 'change'
  },
  props: ['storeItem'],
  data() {
    return {
      storeList: [],
      activeStore: null
    }
  },
  watch: {
    activeStore: {
      handler(val) {
        this.$emit('change', val)
      },
      deep: true
    }
  },
  mounted() {
    this.getStoreList();
  },
  methods: {
    async getStoreList() {
      let res = await this.$q.preSalePlan.planGetShop();
      if(res.success && res.data) {
        this.storeList = res.data;
      }
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>